import React from 'react'
import { motion } from 'framer-motion'

// Unified Broxel Loading Animation - Single consistent loader across the site
interface LoadingAnimationProps {
  size?: 'sm' | 'md' | 'lg'
  className?: string
  text?: string
}

const LoadingAnimation: React.FC<LoadingAnimationProps> = ({
  size = 'md',
  className = '',
  text
}) => {
  const sizeConfig = {
    sm: { container: 'w-8 h-8', dot: 'w-2 h-2', gap: 8 },
    md: { container: 'w-12 h-12', dot: 'w-3 h-3', gap: 10 },
    lg: { container: 'w-16 h-16', dot: 'w-4 h-4', gap: 12 }
  }

  const config = sizeConfig[size]

  // Broxel brand colors
  const colors = ['#1B4D7A', '#7CB342', '#4CAF50']

  return (
    <div className={`flex flex-col items-center justify-center ${className}`}>
      <div className={`relative ${config.container}`}>
        {/* Three bouncing dots with Broxel colors */}
        {[0, 1, 2].map((i) => (
          <motion.div
            key={i}
            className={`absolute ${config.dot} rounded-full`}
            style={{
              backgroundColor: colors[i],
              left: `${i * config.gap + (size === 'sm' ? 4 : size === 'md' ? 6 : 8)}px`,
              top: '50%'
            }}
            animate={{
              y: [-8, 8, -8],
              scale: [1, 0.8, 1],
              opacity: [1, 0.7, 1]
            }}
            transition={{
              duration: 0.8,
              repeat: Infinity,
              delay: i * 0.15,
              ease: "easeInOut"
            }}
          />
        ))}
      </div>
      {text && (
        <motion.p
          className="mt-3 text-sm text-gray-600 font-medium"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          {text}
        </motion.p>
      )}
    </div>
  )
}

export default LoadingAnimation